<style lang="less">
.box {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
.search-container {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-direction: row;
  width: 698px;
  margin: 16px 32px 40px 32px;
}

.search-container .search-cancel {
  font-size: 28px;
  width: 118px;
  text-align: center;
}

.search {
  width: 600px;
  flex: 1;
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  align-items: center;
  height: 72px;
  background: #f3f7fb;
  padding: 0 18px 0 16px;
  border-radius: 12px;
}

.search .address {
  min-width: 115px;
  overflow: hidden;
}

.search .split-line {
  height: 28px;
  width: 2px;
  margin: 0 20px;
  background: #232C37;
}

.search .search-box {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex: 1;
  -webkit-box-flex: 1;
}

.search .search-box input {
  height: 30px;
  line-height: 30px;
}

.search .search-icon {
  height: 30px;
  width: 32px;
  margin-right: 12px;
}
.search .delete-icon {
  width: 38px;
  height: 38px;
}

.community-title {
  text-align: center;
  color: #89939f;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin: 26px 0;
}

.search-title {
  margin-left: 12px;
  font-size: 28px;
  color: #232C37;
}

.search-content {
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  flex-direction: row;
  flex-wrap: wrap;
}

.search-item {
  padding-left: 12px;
  padding-right: 12px;
  height: 60px;
  line-height: 60px;
  background: #fff;
  border-radius: 6px;
  border: 2px solid rgba(189, 195, 206, 1);
  margin-right: 12px;
  margin-top: 36px;
  color: #6f7884;
  font-size: 28px;
}

.search-history-line {
  height: 0.5px;
  margin-top: 20px;
  background: #e6e6e6;
}

#clear-btn {
  width: 28px;
  height: 30px;
  margin-right: 14.5px;
  margin-bottom: 0px;
}

#search-history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.community-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 0 0 32px;
}
.community-list .community-icon {
  width: 28px;
  height: 34px;
  margin-right: 28px;
}
.search-list {
  height: 142px;
  line-height: 142px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .search-item-icon{
    width: 30px;
    height: 30px;
  }
  .search-item-right{
    width: 100%;
    border-bottom: 1px solid #eeeeee;
    margin-left: 32px;
    text-align: left;
    font-size:32px;
    font-family:PingFangSC-Regular;
    font-weight:400;
  }
}
.search-input {
  cursor: pointer;
  color: #232C37;
  width: 100%;
  border: none;
  background: #f3f7fb;
}
.search-input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #bdc3ce;
  font-size: 26px;
}
.search-input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bdc3ce;
  font-size: 26px;
}
.search-input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bdc3ce;
  font-size: 26px;
}
.search-input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #bdc3ce;
  font-size: 26px;
}
</style>
<template>
  <div class="box">
    <div class="search-container">
      <div class="search">
        <div class="search-box">
          <!-- <img class="search-icon" src="../../assets/img/icon_search_default.png"> -->
          <input
            class="search-input"
            v-model="inputValue"
            @input="setKeyword"
            :focus="focus"
            placeholder="请输入选址目标商圈或小区"
          >
          <img
            class="delete-icon"
            v-if="communityName"
            src="../../assets/img/icon-dump.png"
            @click="deleteSearch"
          >
        </div>
      </div>
      <div class="search-cancel" @click="cancelSearch">取消</div>
    </div>
    <div v-if="historySearchList.length!=0&&!hiddenHistory" class="community-list">
      <div id="search-history-header">
        <label class="search-title">搜索历史</label>
        <img id="clear-btn" src="../../assets/img/clearBtn.png" @click="clearHistory">
      </div>
      <div class="search-content">
        <div
          class="search-item"
          :key="index"
          @click="searchClick(item)"
          v-for="(item,index) in historySearchList"
        >{{item.name}}</div>
      </div>
      <div class="search-history-line"></div>
    </div>
    <div class="hzf-list community-list" v-if="hiddenHistory">
      <div v-if="communityList.length<=0&&showEmpty" class="community-title">没有搜索到相关结果，换个词试试吧</div>
      <div v-else>
        <div class="sdd" @click="goDetail(item)" v-for="(item,index) in communityList" :key="index">
          <div class="search-list">
            <img class="search-item-icon" :src="item.type==1?require('../../assets/img/search-item.png'):require('../../assets/img/cell-icon.png')" />
            <div class="search-item-right" v-html="brightenKeyword(item.name)"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Field } from "vant";
let timer = '';
let timestampStart, timestampEnd;
export default {
  name: "search",
  components: {
    Field
  },
  data() {
    return {
      communityName: "",
      city: {},
      communityList: [],
      inputValue: "",
      historySearchList: [],
      focus: false,
      cityId: 0,
      showEmpty: false,
      timer: '',
      hiddenHistory: false
    };
  },
  created() {
    timestampStart = new Date().getTime();
    this.addBuried({
        source:'1',
        eventType: '曝光事件',
        eventContent: '搜索页'
    });
    let options = this.$route.query;
    this.cityId = options.cityId;
    this.historySearchList = [];
    let historyList = JSON.parse(
      localStorage.getItem("searchHistoryList" + this.cityId)
    );
    if (historyList) {
      for (let i = 0; i < historyList.length; i++) {
        if (historyList[i].cityId == this.cityId) {
          this.historySearchList.push(historyList[i]);
        }
      }
    }
  },
  mounted() {
    // 获取键盘焦点，修复iphone6问题，使用setTimeout
    this.timer = setTimeout(() => {
      this.focus = true;
    }, 500);
  },
  methods: {
    brightenKeyword(val, keyword) {
      keyword = this.communityName;
      val = val + '';
      if (val.indexOf(keyword) !== -1 && keyword !== '') {
            return val.replace(keyword, '<font color="#4169E1">' + keyword + '</font>')
      } else {
          return val
        }
    },
    setKeyword(e) {
      let keyWord = this.inputValue;
      this.communityName = keyWord;
      if (keyWord) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          this.getCommunityList();
        }, 300);
      } else {
        this.communityList = [];
      }
    },
    setSearch(zoneId, name, latitude, longitude) {
      var index = this.historySearchList.indexOf(name);
      if (index == -1) {
        if (this.historySearchList.length > 7) {
          this.historySearchList.pop();
        }
      } else {
        this.historySearchList.splice(index, 1);
      }
      let historyList = JSON.parse(
        localStorage.getItem("searchHistoryList" + this.cityId)
      );
      if (!historyList || historyList.length == 0) {
        this.historySearchList.unshift({
          cityId: this.cityId,
          name: name,
          zoneId: zoneId,
          latitude: latitude,
          longitude: longitude
        });
      } else {
        for (let i = 0; i < historyList.length; i++) {
          if (historyList[i].name == name) {
            let item = historyList[0];
            historyList[0] = historyList[i];
            historyList[i] = item;
            localStorage.setItem(
              "searchHistoryList" + this.cityId,
              JSON.stringify(historyList)
            );
            return false;
          }
        }
        this.historySearchList.unshift({
          cityId: this.cityId,
          name: name,
          zoneId: zoneId,
          latitude: latitude,
          longitude: longitude
        });
      }
      localStorage.setItem(
        "searchHistoryList" + this.cityId,
        JSON.stringify(this.historySearchList)
      );
    },
    //清空历史
    clearHistory() {
      this.historySearchList = [];
      localStorage.removeItem("searchHistoryList" + this.cityId);
      Toast("历史搜索清除成功");
    },
    deleteSearch() {
      this.communityName = "";
      this.inputValue = "";
      this.communityList = [];
    },
    cancelSearch(e) {
      this.communityName = "";
      this.inputValue = "";
      this.communityList = [];
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateBack();
        } else {
          this.$router.go(-1);
        }})
    },
    async getCommunityList() {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      await this.$axios
        .post("api/xz/zone/fuzzy/search/", {
          cityId: this.cityId,
          zoneName: this.inputValue
        })
        .then(res => {
          if (res.success) {
            this.showEmpty = true;
            this.hiddenHistory = true;
            this.communityList = res.result;
          }
          Toast.clear();
        })
        .catch(err => {
          console.log(err);
        });
    },
    goDetail(item) {
      let zoneId = item.value;
      let name = item.name;
      let latitude = item.latitude;
      let longitude = item.longitude;
      this.setSearch(zoneId, name, latitude, longitude);
      let miniUrl,h5Url;
      if (item.type==1) {
        miniUrl = "/pages/area_detail/index?zoneId=" + zoneId +"&latitude=" +latitude +"&longitude=" +longitude +"&cityId=" + this.cityId
        h5Url = "/area_detail"
      }else{
        miniUrl = "/pages/cell_detail/index?zoneId=" + zoneId +"&latitude=" +latitude +"&longitude=" +longitude +"&cityId=" + this.cityId
        h5Url = "/cell_detail"
      }
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:miniUrl
          });
        } else {
          this.$router.push({
            path: h5Url,
            query: {
              cityId: this.cityId,
              zoneId: zoneId,
              latitude: latitude,
              longitude: longitude
            }
          });
        }
      });
    },
    //点击搜索历史
    searchClick(item) {
      let zoneId = item.zoneId;
      let latitude = item.latitude;
      let longitude = item.longitude;
      let miniUrl,h5Url;
      if (item.type==1) {
        miniUrl = "/pages/area_detail/index?zoneId=" + zoneId +"&latitude=" +latitude +"&longitude=" +longitude +"&cityId=" + this.cityId
        h5Url = "/area_detail"
      }else{
        miniUrl = "/pages/cell_detail/index?zoneId=" + zoneId +"&latitude=" +latitude +"&longitude=" +longitude +"&cityId=" + this.cityId
        h5Url = "/cell_detail"
      }
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:miniUrl
          });
        } else {
          this.$router.push({
            path: h5Url,
            query: {
              cityId: this.cityId,
              zoneId: zoneId,
              latitude: latitude,
              longitude: longitude
            }
          });
        }
      });
    }
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    timestampEnd = new Date().getTime();
    let residenceTime = timestampEnd - timestampStart;
    this.addBuried({
        source:'1',
        eventType: '页面停留时长',
        eventContent: '搜索页停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/search/index.vue